module.exports = __webpack_public_path__ + "media/images/b2b_admin/trip_details_mini_screen-881374a4b8b83f5c09259ffd957017ff.png";